module.exports = __webpack_public_path__ + "static/FondoSilueta-68183db861e2af16ba8e6e24ad484a28.png";